export enum ActionTypes {
    UPDATE_ME = "profile-module/update-me",
    UPDATE_PASSWORD = "profile-module/update-password",
    UPDATE_SETTINGS = "profile-module/update-settings",
}
